import i18n from 'i18next';
import { API_METHOD, DEFAULT_LOCALE } from '../../constants';
import { history } from 'utils';
import { IMPERSONATION_HEADER, getImpersonatedUsername } from '../Auth/impersonation';

// Gedmo Translatable on the API 500s when a request reaches a translatable
// query without a non-empty `Accept-Language` header. axios DROPS headers
// whose value is undefined/null/empty, so if i18n.language is falsy at the
// moment the request fires (early app boot before init resolves, or a
// detector miss), the header never goes out and the backend explodes.
// Falling back to DEFAULT_LOCALE keeps the contract regardless of i18n state.
const acceptLanguage = () => i18n.language || DEFAULT_LOCALE;

export const apiRequestHeaders = (withAuth = false, method = null) => {
    const token = localStorage.getItem('token');

    if (withAuth && !token) {
        history.push('/auth/login');
        return {
            'Content-Type': method === API_METHOD.PATCH ? 'application/merge-patch+json' : 'application/json',
            'Accept': 'application/json',
            'Accept-Language': acceptLanguage(),
        };
    }

    // «Увійти як користувач»: the super admin's own token, and whom they are
    // looking through — on every authenticated request (utils/Auth/impersonation.js).
    const impersonated = withAuth ? getImpersonatedUsername() : null;
    const authHeader = withAuth
        ? {
            Authorization: 'Bearer ' + token,
            ...(impersonated ? { [IMPERSONATION_HEADER]: impersonated } : {}),
        }
        : {};

    return {
        'Content-Type': method === API_METHOD.PATCH ? 'application/merge-patch+json' : 'application/json',
        'Accept': 'application/json',
        'Accept-Language' : acceptLanguage(),
        ...authHeader,
    };
};
